import { render, staticRenderFns } from "./right_2.vue?vue&type=template&id=f626dd58&scoped=true&"
import script from "./right_2.vue?vue&type=script&lang=js&"
export * from "./right_2.vue?vue&type=script&lang=js&"
import style0 from "./right_2.vue?vue&type=style&index=0&id=f626dd58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f626dd58",
  null
  
)

export default component.exports